import { StyleSheet } from 'react-native';
import { FOCUS_COLOR } from 'src/theme-v2/focus';
import { brand } from 'src/theme/colors';

export const styles = StyleSheet.create({
  title: {
    fontSize: 16,
    fontWeight: 700,
    textAlign: 'center',
  },
  backButton: {
    borderWidth: 2,
    borderColor: 'transparent',
    padding: 4,
  },
  backButtonFocus: {
    borderColor: FOCUS_COLOR,
  },
  backButtonText: {
    paddingHorizontal: 6,
    paddingVertical: 3,
    fontSize: 14,
    fontWeight: 700,
    lineHeight: 18,
    letterSpacing: 0.16,
    textAlign: 'center',
    color: brand.main.water,
  },
});
